import { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Arrow = ({ dir, onClick, disabled, testid, className = "" }) => (
  <button type="button" onClick={onClick} disabled={disabled} aria-label={dir < 0 ? "Scroll left" : "Scroll right"} data-testid={testid}
    className={`asv-rail-arrow grid h-9 w-9 shrink-0 place-items-center rounded-full disabled:opacity-40 ${className}`}>
    {dir < 0 ? <ChevronLeft className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
  </button>
);

export function Rail({ children, testid, chips = false }) {
  const ref = useRef(null);
  const [edge, setEdge] = useState({ start: true, end: true });
  const check = useCallback(() => {
    const el = ref.current;
    if (el) setEdge({ start: el.scrollLeft <= 2, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 2 });
  }, []);
  useEffect(() => {
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [check, children]);
  const go = (d) => ref.current?.scrollBy({ left: d * ref.current.clientWidth * 0.8, behavior: "smooth" });
  const arrowCls = chips ? "" : "hidden sm:grid";
  return (
    <div className={`flex items-center ${chips ? "gap-2" : "gap-3"}`} data-testid={testid}>
      <Arrow dir={-1} onClick={() => go(-1)} disabled={edge.start} testid={`${testid}-prev`} className={arrowCls} />
      <div ref={ref} onScroll={check} className={`asv-rail flex min-w-0 flex-1 snap-x snap-mandatory overflow-x-auto scroll-smooth ${chips ? "gap-2 py-1" : "gap-5 pb-2"}`} data-testid={`${testid}-track`}>
        {children}
      </div>
      <Arrow dir={1} onClick={() => go(1)} disabled={edge.end} testid={`${testid}-next`} className={arrowCls} />
    </div>
  );
}

export const RailItem = ({ children }) => (
  <div className="w-[82%] shrink-0 snap-start [&>*]:h-full sm:w-[calc((100%-1.25rem)/2)] lg:w-[calc((100%-3.75rem)/4)]">{children}</div>
);
